import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import {
  defaultTellingen,
  type EnvironmentSettings,
  type LinkItem,
} from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Mutaties, {
  isVisible: (settings: EnvironmentSettings) =>
    settings.isActiveAdviseur || settings.isInterneGebruiker,
  create: (settings: EnvironmentSettings): LinkItem => {
    const tellingen = settings.tellingen ?? defaultTellingen;

    return {
      itemtype: 'link',
      menuItem: MenuItems.Mutaties,
      title: 'Mutaties',
      url: '/app/aanvraag/recente-activiteiten/mutaties',
      iconclass: 'far fa-pen-to-square',
      showbadge: !!tellingen.aantalMutatieAanvragen,
      badgecontent: tellingen.aantalMutatieAanvragen,
      target: '_top',
    };
  },
});
